package com.eladfinish.bible.contest.ui.common

import io.ktor.util.date.getTimeMillis

class LastBackPressState(
    private val thresholdMs: Long = 3_000L,
) {
    private var lastPressMs: Long = 0L

    fun handle(
        onFirstPress: () -> Unit,
        onSecondPress: () -> Unit,
    ) {
        val now = getTimeMillis()
        return if (now - lastPressMs > thresholdMs) {
            lastPressMs = now
            onFirstPress()
        } else {
            onSecondPress()
        }
    }
}
